import strings from '../utils/strings';
import roundWithDecimals from '../utils/roundWithDecimals';
export const DEVELOPMENT = 'development';
export const PRODUCTION = 'production';
export const TESTING = 'testing';
const validEnvironments = [DEVELOPMENT, TESTING, PRODUCTION];

const environmentFromEnvVars =
	process.env.REACT_APP_ENVIRONMENT?.toLowerCase() ||
	process.env.NODE_ENV ||
	'production';

export const ENVIRONMENT = validEnvironments.includes(environmentFromEnvVars)
	? environmentFromEnvVars
	: PRODUCTION; //Default to production, in case config is missing

if (!validEnvironments.includes(ENVIRONMENT)) {
	console.warn('MISSING ENVIRONMENT SELECTOR');
}
export const LANGUAGE = process.env.REACT_APP_LANGUAGE ?? 'no';
export const timeSinceWCaltered = 1686585143000;
const rootUrls = {
	development: '',
	testing: '',
	production: '',
};
export const ROOT_URL = rootUrls[ENVIRONMENT];

const endpointUrls = {
	development: 'http://localhost:3000',
	testing:
		LANGUAGE === 'de'
			? 'https://api.staging.dysmate.de'
			: 'http://lit-testing.eu-central-1.elasticbeanstalk.com',
	production:
		LANGUAGE === 'de'
			? 'https://api.dysmate.de'
			: 'https://screeningtest.literate.no',
};

export const ENDPOINT_URL = endpointUrls[ENVIRONMENT];

strings.setLanguage(LANGUAGE);

const getFollowupTestUrl = () => {
	const languages = {
		no: {
			development: 'http://localhost:3003',
			testing:
				'http://lit-staging-childtest.s3-website.eu-central-1.amazonaws.com/',
			production: 'http://barnetest.literate.no',
		},
		se: {
			development: 'http://localhost:3003',
			testing:
				'http://followup.dysmate.se.s3-website.eu-central-1.amazonaws.com/',
			production: 'http://followup.dysmate.se',
		},
		de: {
			development: 'http://localhost:3003',
			testing: 'http://followup.staging.dysmate.de',
			production: 'http://followup.dysmate.de',
		},
	};

	return languages[LANGUAGE][ENVIRONMENT];
};

export const CHILD_TEST_URL = getFollowupTestUrl();

const childtestUrls = {
	development: 'http://localhost:3003',
	testing:
		'http://lit-staging-childtest.s3-website.eu-central-1.amazonaws.com/',
	production: 'http://barnetest.literate.no',
};

export const USER_MESSAGE = true;
export const TEST_TYPES = {
	CHILD_SCREENING: 'child-screening',
	CHILD_FOLLOWUP: 'child-followup',
	CHILD_NORMING: 'child-norming',
	ADULT_SCREENING: 'adult-screening',
	ADULT_FOLLOWUP: 'adult-followup',
	YOUTH_SCREENING: 'youth-screening',
	YOUTH_FOLLOWUP: 'youth-followup',
};

export const TEST_TYPE_NAMES = {
	'child-screening': `${strings.screeningtest} (${strings.child})`,
	'child-followup': `${strings.followuptest} (${strings.child})`,
	'child-norming': `${strings.screeningtest} (${strings.singleChild})`,
	'adult-screening': `${strings.screeningtest} (${strings.adult})`,
	'adult-followup': `${strings.followuptest} (${strings.adult})`,
	'youth-screening': `${strings.screeningtest} (${strings.youth})`,
	'youth-followup': `${strings.followuptest} (${strings.youth})`,
};

export const ALL = {
	id: 'all',
	label: strings.all,
};

export const SEARCHBYTESTKEY = {
	id: 'search',
	label: strings.searchByTestKey,
};

export const CREATENOTIFICATION = {
	id: 'create',
	label: strings.createNotification,
};

export const VIEWNOTIFICATION = {
	id: 'view',
	label: strings.viewNotification,
};

export const STATUS = {
	id: '',
	label: strings.status,
};

export const SATUS = {
	id: 'all',
	label: strings.all,
};

export const LOGGED_IN = {
	id: 'logged_in',
	label: strings.loggedIn,
};
export const BLOCKED = {
	id: 'blocked',
	label: strings.blocked,
};

export const TEST_ACTIVITY = {
	id: 'test',
	label: 'test hendelser',
};
export const USER_ACTIVITY = {
	id: 'user',
	label: 'user hendelser',
};
export const SUPER_ACTIVITY = {
	id: 'super',
	label: 'super hendelser',
};

export const NOT_STARTED = {
	id: 'not_started',
	label: strings.notstarted,
};

export const NOT_DISTRIBUTED = {
	id: 'not_distributed',
	label: strings.notdistributed,
};

export const NOT_INVOICED = {
	id: 'not_invoiced',
	label: 'Ikke fukturert',
};
export const INVOICED = {
	id: 'invoiced',
	label: 'Fukturert',
};
export const DISTRIBUTED = {
	id: 'distributed',
	label: strings.distributed,
};

export const STARTED = {
	id: 'started',
	label: strings.started,
};

export const COMPLETED = {
	id: 'completed',
	label: strings.completed,
};

export const MALE = {
	id: 'm',
	label: strings.male,
};

export const FEMALE = {
	id: 'f',
	label: strings.female,
};
export const YOUNG_MALE = {
	id: 'm',
	label: strings.boy,
};

export const YOUNG_FEMALE = {
	id: 'f',
	label: strings.girl,
};

export const GENDER_LABELS = {
	f: strings.female,
	m: strings.male,
};

export const TEST_USER_INFO_LABELS = {
	juniorHigh: 'ungdomsskole',
	highSchool: 'videregående skole',
	bachelor: 'bachelor',
	master: 'mastergrad/hovedfag',
	phd: 'doktorgrad',
	youthProgram: 'Ungdomsprogram',
	accompanyingMeasures: 'Oppfølgingstiltak',
	workPreparatoryTraining: 'Arbeidsforberedende trening',
	norwegian: 'norsk',
	sapmi: 'samisk',
	russian: 'russisk',
	english: 'engelsk',
	arabic: 'arabisk',
	polish: 'polsk',
	kurdish: 'kurdisk',
	spanish: 'spansk',
	tamil: 'tamil',
	thai: 'thai',
	turkish: 'tyrkisk',
	other: 'annet',
	yes: 'ja',
	no: 'nein',
	doesNotKnow: 'vet ikke',
};

export const BANK_ID = 'BankID';
export const BANK_ID_MOBILE = 'BankIDMobile';
export const FEIDE = 'feide';

export const TEST_PRICE = 50;
export const SUBSCRIPTION_PRICE = 0;
export const CURRENCY_SYMBOL = strings.currencysymbol;

export const Z_SCORE_OFFSET = 4;
export const Z_SCORE_MAX = 8;

export const MINIMUM_AGE = 0;
export const MAXIMUM_AGE = 100;

const ORDDIKTAT = 'ORDDIKTAT';
const ORDKJEDETESTEN = 'ORDKJEDETESTEN';
const TULLEORDTESTEN = 'TULLEORDTESTEN';
const BYTTELYDTESTEN = 'BYTTELYDTESTEN';
const SKRIVEHASTIGHET = 'SKRIVEHASTIGHET';
const LESEPRØVEN = 'LESEPRØVEN';
const ORDFORSTÅELSE = 'ORDFORSTÅELSE';
const WORKING_MEMORY = 'WORKING_MEMORY';
const WORKING_MEMORY_NUMBERS = 'WORKING_MEMORY_NUMBERS';
const WORKING_MEMORY_WORDS = 'WORKING_MEMORY_WORDS';
const RAPID_NOMINATION = 'RAPID_NOMINATION';
const MINUTE = 'MINUTE';
const SPOONERISM = 'SPOONERISM';
const LETTER_KNOWLEDGE = 'LETTER_KNOWLEDGE';
const PHONEME_ISOLATION = 'PHONEME_ISOLATION';
const PHONEME_DELETION = 'PHONEME_DELETION';

export const TEST_STEPS = {
	ORDDIKTAT,
	ORDKJEDETESTEN,
	TULLEORDTESTEN,
	SKRIVEHASTIGHET,
	LESEPRØVEN,
	ORDFORSTÅELSE,
};

export const TEST_STEP_IDS = {
	[ORDDIKTAT]: 1,
	[ORDKJEDETESTEN]: 2,
	[TULLEORDTESTEN]: 3,
	[SKRIVEHASTIGHET]: 4,
	[LESEPRØVEN]: 5,
	[ORDFORSTÅELSE]: 6,
};

export const controlPanel = '/control-panel';
export const notifications = '/notifications';

export const TEST_STEPS_BY_ID = {
	1: {
		name: ORDDIKTAT,
		questionCount: 45,
		label: 'Wörter schreiben',
		reportHeading: strings.orddiktatheading,
		reportExplaination: strings.orddiktatadultexplanation,
		reportVariableText: strings.orddiktatvariabletext,
		norms: {
			default: {average: 38.38, standardDeviation: 4.54},
		},
	},
	2: {
		name: ORDKJEDETESTEN,
		questionCount: 56,
		label: 'Wortketten trennen',
		reportHeading: strings.ordkjedetestenheading,
		reportExplaination: strings.ordkjedetestenexplanation,
		reportVariableText: strings.ordkjedetestenvariabletext,
		norms: {
			default: {average: 15.38, standardDeviation: 5.1},
		},
	},
	3: {
		name: TULLEORDTESTEN,
		questionCount: 25,
		label: 'Pseudohomophone erkennen',
		reportHeading: strings.tulleordtestenheading,
		reportExplaination: strings.tulleordtestenexplanation,
		reportVariableText: strings.tulleordtestenvariabletext,
		norms: {
			default: {average: 13.87, standardDeviation: 5.07},
		},
	},
	4: {
		name: SKRIVEHASTIGHET,
		questionCount: 0,
		label: 'Einen Satz abschreiben',
		reportHeading: strings.skrivehastighetheading,
		reportExplaination: strings.skrivehastighetexplanation,
		reportVariableText: strings.skrivehastighetvariabletext,
		norms: {
			default: {average: 20.28, standardDeviation: 3.76},
		},
	},
	5: {
		name: LESEPRØVEN,
		questionCount: 14,
		label: 'Einen Text verstehen',
		reportHeading: strings.leseprøvenheading,
		reportExplaination: strings.leseprøvenexplanation,
		reportVariableText: strings.leseprøvenvariabletext,
		norms: {
			default: {average: 9.21, standardDeviation: 2.68},
		},
	},
	6: {
		name: ORDFORSTÅELSE,
		questionCount: 15,
		label: 'Ähnliche Wörter finden',
		reportHeading: strings.ordforståelseheading,
		reportExplaination: strings.ordforståelseexplanation,
		reportVariableText: strings.ordforståelsevariabletext,
		norms: {
			default: {average: 10.55, standardDeviation: 2.56},
		},
	},
};
export const YOUTH_TEST_STEP_IDS = {
	[ORDDIKTAT]: 1,
	[ORDKJEDETESTEN]: 2,
	[TULLEORDTESTEN]: 3,
	[SKRIVEHASTIGHET]: 4,
	[LESEPRØVEN]: 5,
	[ORDFORSTÅELSE]: 6,
};

export const YOUTH_TEST_STEPS_BY_ID = {
	1: {
		name: ORDDIKTAT,
		questionCount: 40,
		label: 'Wörter schreiben',
		reportHeading: strings.orddiktatheading,
		reportExplaination: strings.orddiktatyouthexplanation,
		reportVariableText: strings.orddiktatvariabletext,
		getPredictedScore: (genderValue, foreignValue, gradeValue) => {
			const gender = Number(genderValue);
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const predictedTestScore = Math.sqrt(
				531.3 - 54 * gender + 69.1 * (grade - 7) - 147.4 * foreign
			);
			return roundWithDecimals(predictedTestScore, 2);
		},
		norms: {
			7: {average: 17.41, standardDeviation: 5.43},
			8: {average: 17.41, standardDeviation: 5.43},
			9: {average: 20.59, standardDeviation: 5.43},
			10: {average: 21.63, standardDeviation: 5.43},
		},
	},
	2: {
		name: ORDKJEDETESTEN,
		questionCount: 50,
		label: 'Wortketten trennen',
		reportHeading: strings.ordkjedetestenheading,
		reportExplaination: strings.ordkjedetestenyouthexplanation,
		reportVariableText: strings.ordkjedetestenvariabletext,
		getPredictedScore: (genderValue, foreignValue, gradeValue) => {
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const predictedTestScore =
				17.07 +
				0.33 * (grade - 7) +
				0.86 * Math.pow(grade - 7, 2) -
				1.63 * foreign;
			return roundWithDecimals(predictedTestScore, 2);
		},
		norms: {
			7: {average: 11.44, standardDeviation: 7.65},
			8: {average: 11.44, standardDeviation: 7.65},
			9: {average: 15.07, standardDeviation: 7.65},
			10: {average: 16.61, standardDeviation: 7.65},
		},
	},
	3: {
		name: TULLEORDTESTEN,
		questionCount: 32,
		label: 'Pseudohomophone erkennen',
		reportHeading: strings.tulleordtestenheading,
		reportExplaination: strings.tulleordtestenexplanation,
		reportVariableText: strings.tulleordtestenvariabletext,
		getPredictedScore: (genderValue, foreignValue, gradeValue) => {
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const predictedTestScore =
				9.87 + 1.25 * (grade - 7) - 1.05 * foreign;
			return roundWithDecimals(predictedTestScore, 2);
		},
		norms: {
			7: {average: 8.4, standardDeviation: 5.96},
			8: {average: 8.4, standardDeviation: 5.96},
			9: {average: 9.25, standardDeviation: 5.96},
			10: {average: 9.77, standardDeviation: 5.96},
		},
	},
	4: {
		name: SKRIVEHASTIGHET,
		questionCount: 0,
		label: 'Einen Satz abschreiben',
		reportHeading: strings.skrivehastighetheading,
		reportExplaination: strings.skrivehastighetexplanation,
		reportVariableText: strings.skrivehastighetvariabletext,
		getPredictedScore: (genderValue, foreignValue, gradeValue) => {
			const gender = Number(genderValue);
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const predictedTestScore =
				16.42 - 2.3 * gender + 2.5 * (grade - 7) - 2.38 * foreign;
			return roundWithDecimals(predictedTestScore, 2);
		},
		norms: {
			7: {average: 18.02, standardDeviation: 7.07},
			8: {average: 18.02, standardDeviation: 7.07},
			9: {average: 23.64, standardDeviation: 7.07},
			10: {average: 27.23, standardDeviation: 7.07},
		},
	},
	5: {
		name: LESEPRØVEN,
		questionCount: 15,
		label: 'Einen Text verstehen',
		reportHeading: strings.leseprøvenyouthheading,
		reportExplaination: strings.leseprøvenyouthexplanation,
		reportVariableText: strings.leseprøvenvariabletext,
		getPredictedScore: (genderValue, foreignValue, gradeValue) => {
			const gender = Number(genderValue);
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const predictedTestScore =
				10.44 - 1.31 * gender + 0.47 * (grade - 7) - 2.68 * foreign;
			return roundWithDecimals(predictedTestScore, 2);
		},
		norms: {
			7: {average: 3.78, standardDeviation: 4.02},
			8: {average: 3.78, standardDeviation: 4.02},
			9: {average: 4.42, standardDeviation: 4.02},
			10: {average: 5.04, standardDeviation: 4.02},
		},
	},
	6: {
		name: ORDFORSTÅELSE,
		questionCount: 20,
		label: 'Ähnliche Wörter finden',
		reportHeading: strings.ordforståelseheading,
		reportExplaination: strings.ordforståelseyouthexplanation,
		reportVariableText: strings.ordforståelsevariabletext,
		getPredictedScore: (genderValue, foreignValue, gradeValue) => {
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const predictedTestScoreRaw =
				777.5 + 51.4 * (grade - 7) - 286.3 * foreign;
			const predictedTestScore = Math.pow(predictedTestScoreRaw, 1 / 2.4);

			return roundWithDecimals(predictedTestScore, 2);
		},
		norms: {
			7: {average: 13.25, standardDeviation: 3.53},
			8: {average: 13.25, standardDeviation: 3.53},
			9: {average: 14.04, standardDeviation: 3.53},
			10: {average: 14.87, standardDeviation: 3.53},
		},
	},
};

export const CHILD_SCRNG_TEST_STEP_IDS = {
	[ORDDIKTAT]: 1,
	[ORDKJEDETESTEN]: 2,
	[BYTTELYDTESTEN]: 3,
	[SKRIVEHASTIGHET]: 4,
	[LESEPRØVEN]: 5,
	[ORDFORSTÅELSE]: 6,
};

export const CHILD_SCRNG_TEST_STEPS_BY_ID = {
	1: {
		name: ORDDIKTAT,
		questionCount: 25,
		label: 'Wörter schreiben',
		reportHeading: strings.orddiktatchildheading,
		reportExplaination: strings.orddiktatchildexplanation,
		reportVariableText: strings.orddiktatchildvariabletext,
		getPredictedScore: (genderValue, foreignValue, gradeValue) => {
			const gender = Number(genderValue);
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const value =
				531.3 - 54 * gender + 69.1 * (grade - 7) - 147.4 * foreign;
			return roundWithDecimals(Math.sqrt(Math.max(0, value)), 2);
		},
		norms: {
			2: {average: 17.41, standardDeviation: 5.43},
			3: {average: 17.41, standardDeviation: 5.43},
			4: {average: 20.59, standardDeviation: 5.43},
			5: {average: 21.63, standardDeviation: 5.43},
			6: {average: 21.63, standardDeviation: 5.43},
			7: {average: 21.63, standardDeviation: 5.43},
		},
	},
	2: {
		name: ORDKJEDETESTEN,
		questionCount: 168,
		label: 'Wortketten trennen',
		reportHeading: strings.ordkjedetestenchildheading,
		reportExplaination: strings.ordkjedetestenchildexplanation,
		reportVariableText: strings.ordkjedetestenchildvariabletext,
		getPredictedScore: (genderValue, foreignValue, gradeValue) => {
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const predictedTestScore =
				17.07 +
				0.33 * (grade - 7) +
				0.86 * Math.pow(grade - 7, 2) -
				1.63 * foreign;
			return roundWithDecimals(predictedTestScore, 2);
		},
		norms: {
			2: {average: 17.41, standardDeviation: 5.43},
			3: {average: 17.41, standardDeviation: 5.43},
			4: {average: 20.59, standardDeviation: 5.43},
			5: {average: 21.63, standardDeviation: 5.43},
			6: {average: 21.63, standardDeviation: 5.43},
			7: {average: 21.63, standardDeviation: 5.43},
		},
	},
	3: {
		name: BYTTELYDTESTEN,
		questionCount: 20,
		label: 'Laute ersetzen',
		reportHeading: strings.byttelydtestheading,
		reportExplaination: strings.byttelydtestexplanation,
		reportVariableText: strings.byttelydtestvariabletext,
		getPredictedScore: (genderValue, foreignValue, gradeValue) => {
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const predictedTestScore =
				9.87 + 1.25 * (grade - 7) - 1.05 * foreign;
			return roundWithDecimals(predictedTestScore, 2);
		},
		norms: {
			2: {average: 17.41, standardDeviation: 5.43},
			3: {average: 17.41, standardDeviation: 5.43},
			4: {average: 20.59, standardDeviation: 5.43},
			5: {average: 21.63, standardDeviation: 5.43},
			6: {average: 21.63, standardDeviation: 5.43},
			7: {average: 21.63, standardDeviation: 5.43},
		},
	},
	4: {
		name: SKRIVEHASTIGHET,
		questionCount: 0,
		label: 'Einen Satz abschreiben',
		reportHeading: strings.skrivehastighetchildheading,
		reportExplaination: strings.skrivehastighetchildexplanation,
		reportVariableText: strings.skrivehastighetchildvariabletext,
		getPredictedScore: (genderValue, foreignValue, gradeValue) => {
			const gender = Number(genderValue);
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const predictedTestScore =
				16.42 - 2.3 * gender + 2.5 * (grade - 7) - 2.38 * foreign;
			return roundWithDecimals(predictedTestScore, 2);
		},
		norms: {
			2: {average: 17.41, standardDeviation: 5.43},
			3: {average: 17.41, standardDeviation: 5.43},
			4: {average: 20.59, standardDeviation: 5.43},
			5: {average: 21.63, standardDeviation: 5.43},
			6: {average: 21.63, standardDeviation: 5.43},
			7: {average: 21.63, standardDeviation: 5.43},
		},
	},
	5: {
		name: LESEPRØVEN,
		questionCount: 8,
		label: 'Einen Text verstehen',
		reportHeading: strings.leseprøvenchildheading,
		reportExplaination: strings.leseprøvenchildexplanation,
		reportVariableText: strings.leseprøvenchildvariabletext,
		getPredictedScore: (genderValue, foreignValue, gradeValue) => {
			const gender = Number(genderValue);
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const predictedTestScore =
				10.44 - 1.31 * gender + 0.47 * (grade - 7) - 2.68 * foreign;
			return roundWithDecimals(predictedTestScore, 2);
		},
		norms: {
			2: {average: 17.41, standardDeviation: 5.43},
			3: {average: 17.41, standardDeviation: 5.43},
			4: {average: 20.59, standardDeviation: 5.43},
			5: {average: 21.63, standardDeviation: 5.43},
			6: {average: 21.63, standardDeviation: 5.43},
			7: {average: 21.63, standardDeviation: 5.43},
		},
	},
	6: {
		name: ORDFORSTÅELSE,
		questionCount: 17,
		label: ' Ähnliche Wörter finden',
		reportHeading: strings.ordforståelsechildheading,
		reportExplaination: strings.ordforståelsechildexplanation,
		reportVariableText: strings.ordforståelsechildvariabletext,
		getPredictedScore: (genderValue, foreignValue, gradeValue) => {
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const predictedTestScoreRaw =
				777.5 + 51.4 * (grade - 7) - 286.3 * foreign;
			const predictedTestScore = Math.pow(predictedTestScoreRaw, 1 / 2.4);

			return roundWithDecimals(predictedTestScore, 2);
		},
		norms: {
			2: {average: 17.41, standardDeviation: 5.43},
			3: {average: 17.41, standardDeviation: 5.43},
			4: {average: 20.59, standardDeviation: 5.43},
			5: {average: 21.63, standardDeviation: 5.43},
			6: {average: 21.63, standardDeviation: 5.43},
			7: {average: 21.63, standardDeviation: 5.43},
		},
	},
};

export const CHILD_TEST_STEPS = {
	WORKING_MEMORY,
	WORKING_MEMORY_NUMBERS,
	WORKING_MEMORY_WORDS,
	RAPID_NOMINATION,
	MINUTE,
	SPOONERISM,
	LETTER_KNOWLEDGE,
	PHONEME_ISOLATION,
	PHONEME_DELETION,
	ORDDIKTAT,
};

export const CHILD_TEST_STEPS_BY_ID = {
	0: {
		name: WORKING_MEMORY,
		questionCount: 20,
		showTotalCorrect: false,
		label: 'Arbeitsgedächtnis',
		reportHeading: strings.arbeidsminneheading,
		reportExplaination: strings.arbeidsminneexplanation,
		reportChildExplaination: strings.arbeidsminneChildexplanation,
		reportVariableText: strings.arbeidsminnevariabletext,
		reportChildVariableText: strings.arbeidsminnechildvariabletext,
		getPredictedScore: (foreignValue, gradeValue) => {
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const predictedTestScore =
				9.52 -
				0.47 * (grade - 7) +
				0.39 * Math.pow(grade - 7, 2) -
				1.19 * foreign;
			return roundWithDecimals(predictedTestScore, 2);
		},
		norms: {
			0: {average: 3.79, standardDeviation: 2.62},
			1: {average: 6.37, standardDeviation: 2.62},
			2: {average: 6.95, standardDeviation: 2.62},
			3: {average: 7.23, standardDeviation: 2.62},
			4: {average: 8.24, standardDeviation: 2.62},
			5: {average: 8.62, standardDeviation: 2.62},
			6: {average: 9.08, standardDeviation: 2.62},
			7: {average: 9.25, standardDeviation: 2.62},
			8: {average: 10.5, standardDeviation: 2.62},
			9: {average: 10.5, standardDeviation: 2.62},
			10: {average: 10.5, standardDeviation: 2.62},
			adult: {average: 10.4, standardDeviation: 2.62},
		},
	},
	1: {
		name: WORKING_MEMORY_NUMBERS,
		questionCount: 12,
		showTotalCorrect: false,
		label: strings.workingmemorytestNumbers,
		reportHeading: strings.arbeidminneheading,
		reportHeading: strings.arbeidsminnenummberheading,
		getPredictedScore: (foreignValue, gradeValue) => {
			const gender = Number(gradeValue);
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const predictedTestScore = Math.sqrt(
				531.3 - 54 * gender + 69.1 * (grade - 7) - 147.4 * foreign
			);
			return roundWithDecimals(predictedTestScore, 2);
		},
		norms: {
			0: {average: 3.79, standardDeviation: 2.84},
			1: {average: 6.37, standardDeviation: 1.87},
			2: {average: 6.95, standardDeviation: 1.63},
			3: {average: 7.23, standardDeviation: 2.15},
			4: {average: 8.24, standardDeviation: 2.14},
			5: {average: 8.62, standardDeviation: 2.09},
			6: {average: 9.08, standardDeviation: 2.45},
			7: {average: 9.25, standardDeviation: 2.27},
			8: {average: 10.5, standardDeviation: 2.67},
			9: {average: 10.5, standardDeviation: 2.67},
			10: {average: 10.5, standardDeviation: 2.67},
			adult: {average: 10.4, standardDeviation: 2.57},
		},
	},
	2: {
		name: WORKING_MEMORY_WORDS,
		showTotalCorrect: false,
		questionCount: 12,
		label: strings.workingmemorytestWords,
		reportHeading: strings.arbeidsminnenummberheading,
		getPredictedScore: (foreignValue, gradeValue) => {
			const gender = Number(gradeValue);
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const predictedTestScore = Math.sqrt(
				531.3 - 54 * gender + 69.1 * (grade - 7) - 147.4 * foreign
			);
			return roundWithDecimals(predictedTestScore, 2);
		},
		norms: {
			0: {average: 3.79, standardDeviation: 2.84},
			1: {average: 6.37, standardDeviation: 1.87},
			2: {average: 6.95, standardDeviation: 1.63},
			3: {average: 7.23, standardDeviation: 2.15},
			4: {average: 8.24, standardDeviation: 2.14},
			5: {average: 8.62, standardDeviation: 2.09},
			6: {average: 9.08, standardDeviation: 2.45},
			7: {average: 9.25, standardDeviation: 2.27},
			8: {average: 10.5, standardDeviation: 2.67},
			9: {average: 10.5, standardDeviation: 2.67},
			10: {average: 10.5, standardDeviation: 2.67},
			adult: {average: 10.4, standardDeviation: 2.57},
		},
	},
	3: {
		name: RAPID_NOMINATION,
		showTotalCorrect: false,
		questionCount: 50,
		label: 'Automatisiertes Schnellbenennen',
		reportHeading: strings.hurtigbenevningheading,
		reportExplaination: strings.hurtigbenevningexplanation,
		reportBHexplaination: strings.hurtigbenevningBHexplanation,
		reportChildExplaination: strings.hurtigbenevningChildexplanation,
		reportVariableText: strings.hurtigbenevningvariabletext,
		reportChildVariableText: strings.hurtigbenevningchildvariabletext,
		getPredictedScore: (foreignValue, gradeValue) => {
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const predictedTestScore =
				0.634 + 0.044 * (grade - 7) - 0.087 * foreign;
			return roundWithDecimals(predictedTestScore, 2);
		},
		norms: {
			0: {average: 0.22, standardDeviation: 0.147},
			1: {average: 0.3, standardDeviation: 0.147},
			2: {average: 0.34, standardDeviation: 0.147},
			3: {average: 0.48, standardDeviation: 0.147},
			4: {average: 0.49, standardDeviation: 0.147},
			5: {average: 0.55, standardDeviation: 0.147},
			6: {average: 0.59, standardDeviation: 0.147},
			7: {average: 0.59, standardDeviation: 0.147},
			8: {average: 0.69, standardDeviation: 0.147},
			9: {average: 0.69, standardDeviation: 0.147},
			10: {average: 0.69, standardDeviation: 0.147},
			adult: {average: 0.79, standardDeviation: 0.147},
		},
	},
	4: {
		name: MINUTE,
		showTotalCorrect: false,
		questionCount: 119,
		label: '1-Minute-Lesetest',
		reportHeading: strings.ettminuttstestheading,
		reportExplaination: strings.ettminuttstestexplanation,
		reportChildExplaination: strings.ettminuttstestChildexplanation,
		reportVariableText: strings.ettminuttstestvariabletext,
		reportChildVariableText: strings.ettminuttstestchildvariabletext,
		getPredictedScore: (foreignValue, gradeValue) => {
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const predictedTestScore = 78.35 + 5.65 * (grade - 7);
			return roundWithDecimals(predictedTestScore, 2);
		},
		norms: {
			1: {average: 17.07, standardDeviation: 18.68},
			2: {average: 37.99, standardDeviation: 18.68},
			3: {average: 52.68, standardDeviation: 18.68},
			4: {average: 58.36, standardDeviation: 18.68},
			5: {average: 69.12, standardDeviation: 18.68},
			6: {average: 74.18, standardDeviation: 18.68},
			7: {average: 77.17, standardDeviation: 18.68},
			8: {average: 85.75, standardDeviation: 18.68},
			9: {average: 85.75, standardDeviation: 18.68},
			10: {average: 85.75, standardDeviation: 18.68},
			adult: {average: 94.38, standardDeviation: 18.68},
		},
	},
	5: {
		name: SPOONERISM,
		showTotalCorrect: true,
		questionCount: 20,
		label: 'Phonologische Bewusstheit',
		reportHeading: strings.spoonerismheading,
		reportExplaination: strings.spoonerismexplanation,
		reportVariableText: strings.spoonerismvariabletext,
		getPredictedScore: (foreignValue, gradeValue) => {
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const predictedTestScoreRaw = 0.32 + 0.023 * (grade - 7);
			const predictedTestScore = Math.pow(predictedTestScoreRaw, 2);
			return roundWithDecimals(predictedTestScore, 2);
		},
		norms: {
			7: {average: 0.12, standardDeviation: 0.105},
			8: {average: 0.12, standardDeviation: 0.105},
			9: {average: 0.12, standardDeviation: 0.105},
			10: {average: 0.12, standardDeviation: 0.105},
			adult: {average: 0.147, standardDeviation: 0.105},
		},
	},
	6: {
		name: LETTER_KNOWLEDGE,
		showTotalCorrect: true,
		questionCount: 30,
		label: strings.letterknowledgetest,
		reportHeading: strings.bokstavkunnskapheading,
		reportExplaination: strings.bokstavkunnskapexplanation,
		reportVariableText: strings.bokstavkunnskapvariabletext,
		reportVariableTextBH: strings.bokstavkunnskapvariabletextBH,
		norms: {
			1: {average: 22.86, standardDeviation: 7.65},
			2: {average: 11.37, standardDeviation: 1.12},
		},
	},
	7: {
		name: PHONEME_ISOLATION,
		showTotalCorrect: true,
		questionCount: 16,
		label: strings.phonemeomissiontest,
		reportHeading: strings.fonemisolasjonheading,
		reportExplaination: strings.fonemisolasjonexplanation,
		reportVariableText: strings.fonemisolasjonvariabletext,
		norms: {
			0: {average: 8.16, standardDeviation: 4.01},
			1: {average: 12.52, standardDeviation: 2.52},
			2: {average: 6.34, standardDeviation: 1.03},
		},
	},
	8: {
		name: PHONEME_DELETION,
		showTotalCorrect: true,
		questionCount: 20,
		label: strings.phonemedeletiontest,
		reportHeading: strings.fonemutelatelseheading,
		reportExplaination: strings.fonemutelatelseexplanation,
		reportVariableText: strings.fonemutelatelsevariabletext,
		//NOt correct predicted scores! Need the new norms!
		getPredictedScore: (foreignValue, gradeValue) => {
			const grade = Number(gradeValue);
			const foreign = Number(foreignValue);
			const predictedTestScore =
				0.634 + 0.044 * (grade - 7) - 0.087 * foreign;
			return roundWithDecimals(predictedTestScore, 2);
		},
		norms: {
			0: {average: 0.22, standardDeviation: 0.147},
			1: {average: 0.3, standardDeviation: 0.147},
			2: {average: 0.34, standardDeviation: 0.147},
			3: {average: 0.48, standardDeviation: 0.147},
			4: {average: 0.49, standardDeviation: 0.147},
			5: {average: 0.55, standardDeviation: 0.147},
			6: {average: 0.59, standardDeviation: 0.147},
			7: {average: 0.59, standardDeviation: 0.147},
			8: {average: 0.69, standardDeviation: 0.147},
			9: {average: 0.69, standardDeviation: 0.147},
			10: {average: 0.69, standardDeviation: 0.147},
			adult: {average: 0.79, standardDeviation: 0.147},
		},
	},
	9: {
		name: ORDDIKTAT,
		showTotalCorrect: true,
		questionCount: 13,
		label: strings.oneminutetest,
		reportHeading: strings.orddiktatheading,
		reportExplaination: strings.orddiktatchildexplanation,
		reportVariableText: strings.orddiktatvariabletext,
		norms: {
			3: {average: 6.81, standardDeviation: 2.19},
			4: {average: 7.4, standardDeviation: 3.23},
			5: {average: 9.07, standardDeviation: 2.6},
			6: {average: 9.4, standardDeviation: 3.06},
			7: {average: 9.81, standardDeviation: 2.22},
		},
	},
	12: {
		name: MINUTE,
		showTotalCorrect: false,
		questionCount: 120,
		label: strings.oneminutetest,
		reportHeading: strings.ettminuttstestheading,
		reportExplaination: strings.ettminuttstestexplanation,
		reportVariableText: strings.ettminuttstestvariabletext,
		norms: {
			1: {average: 17.07, standardDeviation: 11.58},
			2: {average: 37.99, standardDeviation: 17.81},
			3: {average: 52.68, standardDeviation: 18.96},
			4: {average: 58.36, standardDeviation: 14.86},
			5: {average: 69.12, standardDeviation: 15.2},
			6: {average: 74.18, standardDeviation: 14.36},
			7: {average: 77.17, standardDeviation: 13.69},
			8: {average: 85.75, standardDeviation: 10.336},
			9: {average: 85.75, standardDeviation: 10.336},
			10: {average: 85.75, standardDeviation: 10.336},
		},
	},
};

// User stages
export const TRIAL_TEST_LIMIT = 2;

export const NEEDS_APPROVAL = 'NEEDS_APPROVAL';
export const AWAITING_CONFIRMATION = 'AWAITING_CONFIRMATION';
export const TRIAL = 'TRIAL';
export const EXPIRED_TRIAL = 'EXPIRED_TRIAL';
export const BASIC = 'BASIC';
export const FULL = 'FULL';

export const ADULT = 'ADULT';
export const CHILD = 'CHILD';
export const YOUTH = 'YOUTH';
export const INACTIVE = 'INACTIVE';
export const ACTIVE = 'ACTIVE';
export const NORMING = 'NORMING';
export const PRODUKSJON = 'PRODUKSJON';
export const PROD_NORMING = 'PROD_NORMING';
export const CHILD_YOUTH = 'CHILD_YOUTH';
export const CHILD_ADULT = 'CHILD_ADULD';
export const YOUTH_ADULT = 'YOUTH_ADULT';
export const CHILD_YOUTH_ADULT = 'CHILD_YOUTH_ADULT';

export const svensk = {
	id: 2,
	language: 'swedish',
	lang: 'Svensk',
	active: false,
	hideText: 'Svensk ▲',
	revealText: 'Svensk ▼',
	default: false,
	labelId: null,
};

export const norsk = {
	id: 1,
	language: 'norwegian',
	lang: strings.norwegian,
	active: false,
	hideText: strings.norwegian + ' ▲',
	revealText: strings.norwegian + ' ▼',
	default: false,
	labelId: null,
};
export const english = {
	id: 3,
	language: 'english',
	lang: 'Engelsk',
	active: false,
	hideText: 'Engelsk ▲',
	revealText: 'Engelsk ▼',
	default: false,
	labelId: null,
};

export const dutch = {
	id: 4,
	language: 'dutch',
	lang: 'Dutch',
	active: false,
	hideText: 'Dutch ▲',
	revealText: 'Dutch ▼',
	default: false,
	labelId: null,
};

export const german = {
	id: 5,
	language: 'german',
	lang: 'Tysk',
	active: false,
	hideText: 'Tysk ▲',
	revealText: 'Tysk ▼',
	default: false,
	labelId: null,
};

export const language = [norsk, svensk, english, dutch, german];

export const ENGLISH = 'Engelsk';
export const SWEDISH = 'Svensk';
export const NORWEGIAN = 'Norsk';
export const DUTCH = 'Dutch';
export const GERMAN = 'Tysk';

export const USER_SUBSCRIPTIONS_INFO = {
	[ENGLISH]: {
		subscriptionUpdate: {
			language: 'english',
			child: 0,
			youth: 0,
			adult: 0,
			child_followup: 0,
			youth_followup: 0,
			adult_followup: 0,
			norming_child: 0,
			norming_youth: 0,
			norming_adult: 0,
			basic: 0,
		},
	},
	[SWEDISH]: {
		subscriptionUpdate: {
			language: 'swedish',
			child: 0,
			youth: 0,
			adult: 0,
			child_followup: 0,
			youth_followup: 0,
			adult_followup: 0,
			norming_child: 0,
			norming_youth: 0,
			norming_adult: 0,
			basic: 0,
		},
	},
	[NORWEGIAN]: {
		subscriptionUpdate: {
			language: 'norwegian',
			child: 0,
			youth: 0,
			adult: 0,
			child_followup: 0,
			youth_followup: 0,
			adult_followup: 0,
			norming_child: 0,
			norming_youth: 0,
			norming_adult: 0,
			basic: 0,
		},
	},
	[DUTCH]: {
		subscriptionUpdate: {
			language: 'dutch',
			child: 0,
			youth: 0,
			adult: 0,
			child_followup: 0,
			youth_followup: 0,
			adult_followup: 0,
			norming_child: 0,
			norming_youth: 0,
			norming_adult: 0,
			basic: 0,
		},
	},
	[GERMAN]: {
		subscriptionUpdate: {
			language: 'german',
			child: 0,
			youth: 0,
			adult: 0,
			child_followup: 0,
			youth_followup: 0,
			adult_followup: 0,
			norming_child: 0,
			norming_youth: 0,
			norming_adult: 0,
			basic: 0,
		},
	},
};

export const USER_STAGES_INFO = {
	[NEEDS_APPROVAL]: {
		id: NEEDS_APPROVAL,
		className: 'needs-approval',
		longText: strings.needsApprovalLongText,
		text: strings.needsapproval,
	},
	[AWAITING_CONFIRMATION]: {
		id: AWAITING_CONFIRMATION,
		className: 'awaiting',
		longText: strings.awaitingConfirmationLongText,
		text: strings.notcompletedregistration,
	},
	[TRIAL]: {
		id: TRIAL,
		className: 'trial',
		longText: strings.onlyTrialAccess,
		text: strings.trialperiod,
	},
	[BASIC]: {
		id: BASIC,
		className: 'basic',
		longText: strings.onlyReadAccess,
		text: strings.basicsupcription,
		subscriptionUpdates: {
			active: true,
			full: false,
			trial: false,
			child: false,
			youth: false,
			adult: false,
			norming: false,
		},
	},
	[ACTIVE]: {
		id: ACTIVE,
		className: 'active',
		longText: strings.accessMakeTests,
		text: strings.activeSubscription,
		subscriptionUpdates: {
			active: true,
			full: false,
			trial: false,
			child: false,
			youth: false,
			adult: false,
			norming: false,
		},
	},
	[NORMING]: {
		id: NORMING,
		className: 'active',
		longText: strings.accessNormingMakeTests,
		text: strings.norming,
		subscriptionUpdates: {
			active: true,
			full: false,
			trial: false,
			child: false,
			youth: false,
			adult: false,
			norming: false,
		},
	},
	[PRODUKSJON]: {
		id: PRODUKSJON,
		className: 'active',
		longText: strings.accessProdMakeTests,
		text: 'Vollversion',
		subscriptionUpdates: {
			active: true,
			full: false,
			trial: false,
			child: false,
			youth: false,
			adult: false,
			norming: false,
		},
	},
	[PROD_NORMING]: {
		id: PROD_NORMING,
		className: 'active',
		longText: strings.fullAccessToMakeTests,
		text: strings.fullsupscription,
		subscriptionUpdates: {
			active: true,
			full: false,
			trial: false,
			child: false,
			youth: false,
			adult: false,
			norming: false,
		},
	},
	[INACTIVE]: {
		id: INACTIVE,
		className: 'inactive',
		longText: strings.noAccessToMakeTests,
		text: strings.inactive,
		subscriptionUpdates: {
			active: false,
			full: false,
			trial: false,
			child: false,
			youth: false,
			adult: false,
			norming: false,
		},
	},
};
